
import React from "react";
import MainLayout from "@/layout/MainLayout";

const GDPR: React.FC = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-semibold mb-8">GDPR Compliance Notice</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">1. Overview</h2>
          <p>
            HeyGail is committed to ensuring compliance with the European Union's General Data Protection Regulation (GDPR). This notice explains how we collect, process, and protect personal data of individuals in the EU.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">2. Data Controller</h2>
          <p>
            HeyGail acts as the data controller for personal information collected through our website and services. As the data controller, we determine the purposes and means of processing personal data.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">3. Lawful Basis for Processing</h2>
          <p>We process personal data on the following lawful bases:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Consent:</strong> When you have given explicit consent for specific purposes.</li>
            <li><strong>Contractual Necessity:</strong> When processing is necessary to fulfill a contract with you.</li>
            <li><strong>Legitimate Interests:</strong> When processing is necessary for our legitimate interests, provided those interests do not override your fundamental rights and freedoms.</li>
            <li><strong>Legal Obligation:</strong> When processing is necessary to comply with a legal obligation.</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">4. Your Rights Under GDPR</h2>
          <p>If you are in the EU, you have the following rights regarding your personal data:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Right to Access:</strong> You have the right to request copies of your personal data.</li>
            <li><strong>Right to Rectification:</strong> You have the right to request that we correct inaccurate or incomplete information.</li>
            <li><strong>Right to Erasure:</strong> You have the right to request that we delete your personal data in certain circumstances.</li>
            <li><strong>Right to Restrict Processing:</strong> You have the right to request that we restrict the processing of your personal data.</li>
            <li><strong>Right to Data Portability:</strong> You have the right to request that we transfer your data to another controller.</li>
            <li><strong>Right to Object:</strong> You have the right to object to the processing of your personal data.</li>
            <li><strong>Rights Related to Automated Decision Making:</strong> You have the right not to be subject to a decision based solely on automated processing.</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">5. Data Protection Officer</h2>
          <p>
            Our Data Protection Officer can be contacted at dpo@heygail.com for any questions or concerns regarding our data processing practices.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">6. International Data Transfers</h2>
          <p>
            We may transfer personal data to countries outside the European Economic Area (EEA). When we do, we ensure appropriate safeguards are in place to protect your data, such as Standard Contractual Clauses.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">7. Data Breach Notification</h2>
          <p>
            In the event of a personal data breach that is likely to result in a high risk to your rights and freedoms, we will notify you without undue delay.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">8. Changes to This Notice</h2>
          <p>
            We may update this GDPR Compliance Notice from time to time. We will notify you of any changes by posting the new notice on this page and updating the "Last updated" date.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">9. Contact Us</h2>
          <p>
            If you have any questions about this GDPR Compliance Notice or wish to exercise your rights, please contact us at dpo@heygail.com.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default GDPR;
